import React, {useEffect, useState} from "react";
import { Subscription } from "rxjs";
import { Box, AppBar, Tabs, Tab, Typography } from "@mui/material";

import { SoftwareLogs } from "./SoftwareLogs";
import { ChannelInformation } from "../components/ChannelInformation";
import { SimpleTabPanel } from "../components/Header/SimpleTabPanel";
import { translate } from "../i18n";
import { acrAPI } from "../utils/api";
import { License } from "../models/LicenseModel";
import { LogTableContainer } from "components/Logs/Table/LogTableContainer";
import { QualityIndexLog } from "acr-common-models";
import { WatermarkLog } from "models/WatermarkLogModel";
import { Channel } from "models/ChannelModel";
import { useLocation } from "react-router-dom";

function ChannelDetail() {
const subscribtions: Subscription = new Subscription();
//public state = { tab: 0, license: new License(), channel: new Channel() };
const [tab, setTab] = useState(0);
const [license, setLicense] = useState(new License());
const [channel, setChannel] = useState(new Channel());
const location = useLocation();
const isNewChannel = isNaN(location?.state?.id);
const channelId = Number(location?.state?.id);
window.onpopstate = () => {
        window.location.href = "/mosaic";
}

  useEffect(() => {
    const licenseSub = acrAPI.licenseSubjectSnap.subscribe(updateLicense);
    const channelSub =acrAPI.channelsSubject.subscribe(updateChannel);
    acrAPI.getLicenseStatusByTechno("snap");
    return () => {licenseSub?.unsubscribe(); channelSub.unsubscribe}
  },[]);


const updateChannel = (channels: Channel[]): void => {
  const channel = channels.find((channel) => channel.id === channelId);
  if (channel)
    setChannel(channel);
}

const updateLicense = (license: License): void => {
  setLicense(license);
}

// //history manangement, we push this page in order to go back to the mosaic page
// //Note: we can acess to this current page only if we are on the mosaic and if we click on the + button
const a11yProps = (index: any) => {
  return {
    "id": `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const tabChange = (event: React.ChangeEvent<{}>, tabId: number) => {
  setTab(tabId);
};

  return (
    <Box padding={"2em"} width="100%">
      <Box>
        <AppBar position="static">
        <Tabs value={tab} indicatorColor="secondary" textColor="inherit" onChange={tabChange}>
            <Tab data-cy="channel-detail-information" label={translate("channel information")} {...a11yProps(0)}/>
            <Tab
              data-cy="channel-detail-channel-logs-tab"
              disabled={isNewChannel}
              label={translate("channel logs")}
              {...a11yProps(1)}
            />
            <Tab
              data-cy="channel-detail-snap-detection-logs-tab"
              disabled={isNewChannel}
              label={translate("SNAP Detection")}
              {...a11yProps(2)}
            />
            <Tab
              data-cy="channel-detail-ink-detection-logs-tab"
              disabled={isNewChannel}
              label={translate("INK Detection")}
              {...a11yProps(3)}
            />
            { license.qualityIndexEnable &&
              channel?.channelType !== "am" &&
              ( // TODO if qualityIndexEnableFromUI is false, do not display quality index Tab? 
              <Tab
                data-cy="channel-detail-quality-index"
                disabled={isNewChannel}
                label={translate("SNAP Quality Index")}
                {...a11yProps(4)}
              />
            )}
        
            <Box sx={{ flexGrow: 1, textAlign: 'right',  alignItems: 'flex-start' }}>
            <Typography variant="h6" 
              sx={{ 
                mt: 1.5,
                mr: 2,
                flexGrow: 1, 
                textAlign: 'right',
                fontSize: '1rem',
                color: 'white',  
                textTransform: 'none'
              }}>
              { channel.name ? channel.name : ''}
              { channel.id ? ' (Id:' + channel.id + ')': ''}
            </Typography>                
            </Box>
          </Tabs>
        </AppBar>
      </Box>
      <SimpleTabPanel value={tab} index={0}>
        <ChannelInformation channelId={channelId} channelTypeInfo={channel?.channelType} qualityIndexEnableFromLicense={license.qualityIndexEnable}/>
      </SimpleTabPanel>
      <SimpleTabPanel value={tab} index={1}>
        {!isNewChannel && <SoftwareLogs channelId={channelId} />}
      </SimpleTabPanel>
      <SimpleTabPanel value={tab} index={2}>
        {!isNewChannel && <LogTableContainer apiPrefix="watermarkLog" logType={WatermarkLog} channelId={channelId} technology="snap"/>}
      </SimpleTabPanel>
      <SimpleTabPanel value={tab} index={3}>
        {!isNewChannel && <LogTableContainer apiPrefix="watermarkLog" logType={WatermarkLog} channelId={channelId} technology="ink"/>}
      </SimpleTabPanel>
      { license.qualityIndexEnable && 
        channel?.channelType !== "am" && 
        ( // TODO if qualityIndexEnableFromUI is false, do not display quality index Tab?
        <>
          <SimpleTabPanel value={tab} index={4}>
              {!isNewChannel && (
                <LogTableContainer apiPrefix="qualityIndexLog" logType={QualityIndexLog} channelId={channelId} />
              )}
            </SimpleTabPanel>
          </>
        )}
        
      </Box>
    );
  }

export default ChannelDetail;